
import { SigninModule } from "@/store/modules/signin";
import { UserModule } from "@/store/modules/user";
import { Empty } from "ant-design-vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "App",
})
export default class extends Vue {
  simpleImage: any = (Empty as any).PRESENTED_IMAGE_SIMPLE; // Empty.PRESENTED_IMAGE_SIMPLE
  get userInfo() {
    return UserModule.userInfo;
  }

  locale = zhCN;

  mounted() {
    // 浏览器 切换回当前 tab 网页，刷新
    document.addEventListener("visibilitychange", async () => {
      const pgid = localStorage.getItem("page_id");
      if (document.visibilityState !== "hidden" && pgid) {
        if (pgid !== (this.userInfo as any).page_id) {
          location.reload();
        }
      }
    });
    // 浏览器关闭，清除本地存储
    window.addEventListener("beforeunload", (e) => this.clearLocalStrage());
    // iframe页面绑定事件，监听子页面刷新事件
    window.addEventListener("message", (e) => {
      // 子页面重新刷新，可能登录信息过期，这些需要主应用的登录信息
      // data: 消息, origin: 站点, source: 对象引用
      let data = (e as any)?.data;
      if (typeof data !== "string") {
        return; // 消息无法处理，直接返回
      }
      console.log("window-child-message", data);
      const pkey = "window-child-relogin-";
      if (data.indexOf(pkey) !== 0) {
        return; // 消息无法处理，直接返回
      }
      // 截取token信息
      data = data.substring(pkey.length);
      data = data.substring(0, data.indexOf("-"));
      // 当前系统登录信息
      const pgid = (this.userInfo as any).page_id;
      if (pgid?.indexOf(data) === 0) {
        // console.log("window-parent-relogin-" + pgid)
        // 同一个令牌授权的子页面，子页面过期，需要验证主页面是否过期
        UserModule.setCanGetUser(true);
        SigninModule.login();
      } else {
        console.log("window-parent-nologin-" + (pgid || "no_page_id"));
        // 已经如果没有登录信息，或者不是同一个站点信息，暂时不处理
        // location.reload()
      }
    });
    // 监听请求错误事件，如果是401错误，通知上级页面重新登录
    window.addEventListener("plusrequesterror", (e) => {
      // detail: 请求错误详情
      if ((e as any).detail?.message?.indexOf("401") >= 0) {
        console.log("plusrequesterror", e);
        if (window.parent?.postMessage && (UserModule.userInfo as any).page_id) {
          // 应用已经登录，但是token失效，通知上级页面当前应用从新登录行为
          // 这里可能还是有问题，旧的token和新的token冲突导致不可用问题， 最好指定origin, 暂时使用全局
          window.parent.postMessage("window-child-relogin-" + (UserModule.userInfo as any).page_id, "*");
        }
      }
    });
  }

  clearLocalStrage() {
    localStorage.setItem("page_id", "");
    localStorage.setItem("dir-user-detail-depts-open-nodes", "");
  }
}
